export default "__VITE_ASSET__DKLMMGPs__"